import { posthogUTM } from '@/posthog';
import { RPostHog } from '@/posthog/report';
import { type EventMap } from '@/posthog/constants';
import { detectBrowser, detectPlatform } from '@/utils/ua';

const { utm } = posthogUTM();
function ImgUploadReportPoints() {
  let uid: string = 'not_get_user_id';
  let email: string = 'not_get_email';
  let userIdentity: 1 | 2 | 3 = 1;

  const setUserId = (newUid: string) => {
    uid = newUid;
  };

  const setEmail = (newEmail: string) => {
    email = newEmail;
  };

  const setUserIdentity = (newUserIdentity: 1 | 2 | 3) => {
    userIdentity = newUserIdentity;
  };

  // 用户批量上传图即将请求
  const batch_upload_img_request = ({
    fileSize,
    fileType,
  }: Pick<EventMap['batch_upload_img_request'], 'fileSize' | 'fileType'>) => {
    RPostHog('batch_upload_img_request', {
      user_id: uid,
      email: userIdentity === 2 ? 'anonymous' : email,
      user_identity: userIdentity,
      ...utm,
      fileSize,
      fileType,
    });
  };

  // 用户批量上传图成功
  const batch_upload_img_success = ({
    fileSize,
    fileType,
  }: Pick<EventMap['batch_upload_img_success'], 'fileSize' | 'fileType'>) => {
    RPostHog('batch_upload_img_success', {
      user_id: uid,
      email: userIdentity === 2 ? 'anonymous' : email,
      user_identity: userIdentity,
      ...utm,
      fileSize,
      fileType,
    });
  };

  // 用户批量上传图失败
  const batch_upload_img_fail = ({
    title,
    type,
    errorInfo,
    otherInfo,
    fileSize,
    fileType,
  }: Pick<
    EventMap['batch_upload_img_fail'],
    'title' | 'type' | 'errorInfo' | 'otherInfo' | 'fileSize' | 'fileType'
  >) => {
    RPostHog('batch_upload_img_fail', {
      user_id: uid,
      email: userIdentity === 2 ? 'anonymous' : email,
      user_identity: userIdentity,
      ...utm,
      title,
      type,
      errorInfo,
      deviceType: detectPlatform(),
      browserType: detectBrowser(),
      otherInfo: otherInfo || '',
      fileSize: fileSize || 0,
      fileType: fileType || '',
    });
  };

  return {
    setUserId,
    setEmail,
    setUserIdentity,
    batch_upload_img_request,
    batch_upload_img_success,
    batch_upload_img_fail,
  };
}

export const ImgUploadRP = ImgUploadReportPoints();
